export const modalCookiesShowIndicator: boolean = false;
